// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/condition_match_type.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file inventory/v1/condition_match_type.proto.
 */
export const file_inventory_v1_condition_match_type: GenFile = /*@__PURE__*/
  fileDesc("CidpbnZlbnRvcnkvdjEvY29uZGl0aW9uX21hdGNoX3R5cGUucHJvdG8SDGludmVudG9yeS52MSqAAQoSQ29uZGl0aW9uTWF0Y2hUeXBlEiQKIENPTkRJVElPTl9NQVRDSF9UWVBFX1VOU1BFQ0lGSUVEEAASIQodQ09ORElUSU9OX01BVENIX1RZUEVfSU5DTFVERVMQARIhCh1DT05ESVRJT05fTUFUQ0hfVFlQRV9FWENMVURFUxACQr8BChBjb20uaW52ZW50b3J5LnYxQhdDb25kaXRpb25NYXRjaFR5cGVQcm90b1ABWkFnaXRodWIuY29tL2xlbWEuYWkvbGVtbWF0YS9hcGkvcHJvdG8vZ2VuL2ludmVudG9yeS92MTtpbnZlbnRvcnl2MaICA0lYWKoCDEludmVudG9yeS5WMcoCDEludmVudG9yeVxWMeICGEludmVudG9yeVxWMVxHUEJNZXRhZGF0YeoCDUludmVudG9yeTo6VjFiBnByb3RvMw");

/**
 * @generated from enum inventory.v1.ConditionMatchType
 */
export enum ConditionMatchType {
  /**
   * @generated from enum value: CONDITION_MATCH_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONDITION_MATCH_TYPE_INCLUDES = 1;
   */
  INCLUDES = 1,

  /**
   * @generated from enum value: CONDITION_MATCH_TYPE_EXCLUDES = 2;
   */
  EXCLUDES = 2,
}

/**
 * Describes the enum inventory.v1.ConditionMatchType.
 */
export const ConditionMatchTypeSchema: GenEnum<ConditionMatchType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_condition_match_type, 0);

